import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { getDateFormat } from "@utils/datePickerUtils";
import {
  QuoteConditionsInfo,
  FlexRow,
  GridRow,
  SubTitle,
  SubTitleBold,
  MarginTopSection,
} from "./QuoteConditions.styled";
import { Title, FlexRowHeader } from "../../QuoteView.styled";

const QuoteConditions = (props) => {
  const { t, data } = props;

  return (
    <MarginTopSection>
      <FlexRowHeader>
        <Title>{t("QUOTE_SECTION_CONDITIONS")}</Title>
      </FlexRowHeader>
      <QuoteConditionsInfo>
        {!!data?.id && (
          <>
            <GridRow column="1fr 1fr 1fr">
              <div>
                <FlexRow>
                  <SubTitleBold>{t("QUOTE_PAYMENT_CONDITION")} :</SubTitleBold>
                  <SubTitle>
                    {data?.paymentCondition
                      ? data?.paymentCondition.label
                      : "-"}
                  </SubTitle>
                </FlexRow>
                <FlexRow>
                  <SubTitleBold>{t("QUOTE_PAYMENT_TERMS")} :</SubTitleBold>
                  <SubTitle>
                    {data?.paymentTerms ? data?.paymentTerms.label : "-"}
                  </SubTitle>
                </FlexRow>
              </div>

              <div>
                <FlexRow>
                  <SubTitleBold>{t("QUOTE_PAYMENT_METHOD")} :</SubTitleBold>
                  <SubTitle>
                    {data?.paymentMethod ? data?.paymentMethod.label : "-"}
                  </SubTitle>
                </FlexRow>
                <FlexRow>
                  <SubTitleBold>
                    {t("QUOTE_WINNING_PROBABILITY")} :
                  </SubTitleBold>
                  <SubTitle>
                    {data?.winningProbability
                      ? data?.winningProbability + "%"
                      : "-"}
                  </SubTitle>
                </FlexRow>
              </div>
              <div>
                {parseInt(data.status, 10) === 2 && (
                  <FlexRow>
                    <SubTitleBold>{t("QUOTE_EMISSION_DATE")} :</SubTitleBold>
                    <SubTitle textColor="#004C7F">
                      {data.submissionDate
                        ? getDateFormat(data.submissionDate, "YYYY-MM-DD")
                        : ""}
                    </SubTitle>
                  </FlexRow>
                )}
                {(parseInt(data.status, 10) === 1 ||
                  parseInt(data.status, 10) === 2) && (
                  <FlexRow>
                    <SubTitleBold>
                      {t("QUOTE_ESTIMATED_VALIDATION_DATE")} :
                    </SubTitleBold>
                    <SubTitle textColor="#004C7F">
                      {" "}
                      {data.estimatedValidationDate
                        ? getDateFormat(
                            data.estimatedValidationDate,
                            "YYYY-MM-DD"
                          )
                        : "-"}
                    </SubTitle>
                  </FlexRow>
                )}
                {parseInt(data.status, 10) === 3 && (
                  <FlexRow>
                    <SubTitleBold>{t("QUOTE_VALIDATION_DATE")} :</SubTitleBold>
                    <SubTitle textColor="#004C7F">
                      {data.wonDate
                        ? getDateFormat(data.wonDate, "YYYY-MM-DD")
                        : ""}
                    </SubTitle>
                  </FlexRow>
                )}
              </div>
            </GridRow>
            {(parseInt(data.status, 10) === 1 ||
              parseInt(data.status, 10) === 2) && (
              <GridRow column="1fr">
                <div>
                  <FlexRow>
                    <SubTitleBold>{t("QUOTE_DUNNING_ON")} :</SubTitleBold>
                    <SubTitle>
                      {data.dunningDate
                        ? getDateFormat(data.dunningDate, "YYYY-MM-DD")
                        : "-"}{" "}
                      : {data.followupComment ? data.followupComment : "-"}
                    </SubTitle>
                  </FlexRow>
                </div>
              </GridRow>
            )}
          </>
        )}
      </QuoteConditionsInfo>
    </MarginTopSection>
  );
};

QuoteConditions.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(QuoteConditions);
